export const CHANGE_SINGLE_CAMPAIGN_MODAL = "CHANGE_SINGLE_CAMPAIGN_MODAL";
